import { Controller } from "stimulus";

// Keeps a link's ?tab= param synced to the active tab, so the target page
// (whose tabs share the same anchors) opens on the matching tab.
export default class extends Controller {
  static targets = ["link", "tabs"];

  connect() {
    // defer past Materialize's tab init, which picks the single active tab
    requestAnimationFrame(() => this.update());
  }

  update(event) {
    if (!this.hasLinkTarget || !this.hasTabsTarget) return;

    const anchor = this.clickedAnchor(event) || this.activeAnchor();
    if (!anchor || !anchor.startsWith("#") || anchor === "#") return;

    const base = this.linkTarget.getAttribute("href").split(/[?#]/)[0];
    this.linkTarget.setAttribute("href", `${base}?tab=${anchor.slice(1)}`);
  }

  clickedAnchor(event) {
    if (!event) return null;

    const link = event.target.closest("li.tab a");
    return link && link.getAttribute("href");
  }

  activeAnchor() {
    const link = this.tabsTarget.querySelector("li.tab a.active");
    return link && link.getAttribute("href");
  }
}
